import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Box,
  Button,
  Container,
  CssBaseline,
  IconButton,
  Toolbar,
  Typography,
  Avatar,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  TableContainer,
  Stack,
  Link
} from '@mui/material';

import {
    chartsCustomizations,
    dataGridCustomizations,
    datePickersCustomizations,
    treeViewCustomizations,
  } from '../../dashboard/theme/customizations';
import AppTheme from '../../../shared-theme/AppTheme';
import { alpha } from '@mui/material/styles';
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SideMenu from '../../../components/SideMenu';
import { Add } from '@mui/icons-material';
import ProductsForm from './productsform';
import ImportProducts from './importar';
import ProductsTable from './productstable'
import { fetchProductos } from '../../../utils/generalsFetch';
import { useTourContext } from '../../../components/TourProvider';


const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
  };


const Productos = (props) => {

    const [openProductForm, setOpenProductForm] = useState(false)
    const [openImportProducts, setOpenImportProducts] = useState(false)
    const { startSpecificTour } = useTourContext();
  return (
    <Box>
    <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: 'flex' }}>
            <SideMenu />
            <AppNavbar />
            {/* Main content */}
            <Box
            component="main"
            sx={(theme) => ({
                flexGrow: 1,
                backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
                overflow: 'auto',
            })}>
                <Stack
                    spacing={2}
                    sx={{
                    alignItems: 'center',
                    mx: 3,
                    pb: 5,
                    mt: { xs: 8, md: 0 },
                    }}>
                      
                    {!openProductForm && (
                      <Header parent={"Logistica y Almacenes"} child={"Productos"} />
                    )}
                    {openProductForm && (
                          <ProductsForm onClose={()=>{setOpenProductForm(false)}}/>
                        )}

                    <Box sx={{ fontFamily: 'Inter, \"Noto Sans\", sans-serif', minHeight: '100vh' }}>
                        {!openProductForm && !openImportProducts&& (
                        <Container maxWidth="xl" sx={{ py: 5 }}>
                            
                            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                                <Typography variant="h4" fontWeight={700} data-tour="titulo-gestion-productos">Gestión de Productos</Typography>
                                <Box display="flex" flexDirection="row" gap={2}>
                                <Button variant='outlined' sx={{marginLeft:50,marginRight:5, fontWeight:"bold"}} onClick={()=>{setOpenImportProducts(true)}} data-tour="boton-importar-productos">Importar productos</Button>
                                <Button variant="contained" color='primarybutton' startIcon={<Add/>} sx={{fontWeight:"bold"}} onClick={()=>{setOpenProductForm(true)}} data-tour="boton-agregar-producto">Agregar nuevo producto</Button>
                                </Box>
                            </Stack>

                            <ProductsTable data-tour="tabla-productos"></ProductsTable>
                        </Container>
                        )
                        }

                        {openImportProducts && (
                            <Container maxWidth="xl" sx={{ py: 5 }}>
                              <ImportProducts onClose={()=>{setOpenImportProducts(false)}}/>
                            </Container>
                        )}



                    </Box>
                </Stack>
            </Box>
        </Box>
    </AppTheme>
    </Box>

  );
};

export default Productos;
